import { render, staticRenderFns } from "./HealthInsightDetail.vue?vue&type=template&id=081ed3fb"
import script from "./HealthInsightDetail.vue?vue&type=script&lang=js"
export * from "./HealthInsightDetail.vue?vue&type=script&lang=js"
import style0 from "./HealthInsightDetail.vue?vue&type=style&index=0&id=081ed3fb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports